import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import CursorDot from "@/components/site/CursorDot";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import StatsMarquee from "@/components/site/StatsMarquee";
import AsciiDivider from "@/components/site/AsciiDivider";
import Services from "@/components/site/Services";
import Industries from "@/components/site/Industries";
import TrackRecord from "@/components/site/TrackRecord";
import SelectedWork from "@/components/site/SelectedWork";
import PressRibbon from "@/components/site/PressRibbon";
import Impact from "@/components/site/Impact";
import Writing from "@/components/site/Writing";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import ProjectPage from "@/components/site/ProjectPage";
import Seo from "@/components/site/Seo";

function ScrollToHash() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 50);
      return () => clearTimeout(t);
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash, pathname]);
  return null;
}

function Home() {
  useEffect(() => {
    document.title = "JP Kuster — Brand & Marketing, Built to Scale";
  }, []);
  const homeJsonLd = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    name: "JP Kuster — Brand & Marketing Studio",
    url: "https://jpkuster.com/",
    areaServed: ["United States", "Chicago", "Los Angeles"],
    provider: {
      "@type": "Person",
      name: "John \"JP\" Kuster",
      jobTitle: "Senior Brand & Marketing Leader",
    },
    knowsAbout: [
      "Brand Strategy",
      "Growth Marketing",
      "Experiential Marketing",
      "Cultural Marketing",
      "Content Strategy",
    ],
  };
  return (
    <main className="grain" data-testid="home-page">
      <Seo path="/" jsonLd={homeJsonLd} />
      <CursorDot />
      <Nav />
      <Hero />
      <AsciiDivider char="/" label="§ 01 — Highlights" />
      <StatsMarquee />
      <AsciiDivider char="_" />
      <Services />
      <Industries />
      <TrackRecord />
      <AsciiDivider char="/" label="Selected Work" />
      <SelectedWork />
      <PressRibbon />
      <Impact />
      <Writing />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project/:slug" element={<ProjectPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
